import React from 'react'
import PropTypes from 'prop-types'
import Pagination from '../Layout/pagination';
import Paper from '@material-ui/core/Paper';
import Dialog from '@material-ui/core/Dialog';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';

import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state/index';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import IconButton from '@material-ui/core/IconButton';
import { Row, Col } from 'react-flexbox-grid'

import './styles.css'

function Money(n) {
    var c = 2,
      d = ",",
      t = ".",
      s = n < 0 ? "-" : "",
      i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
      j = (j = i.length) > 3 ? j % 3 : 0;
    return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
  };

const ItemUsuario = (props)=>{
    /**
     * nombre : titulo del item
     * descripcion: sub titulo, una linea
     * fecha: seguna linea de sub titulo, timestamp
     * monto: cantidad a la derecha, formateada como moneda
     * opciones: lista de opciones desplegables {nombre: string, handler: func}
     * onClick: click en cualquier lugar del item
     */
        return <div onClick={props.onClick} className='containerItemUsuario'>

                <div style={{display: 'flex'}}>
                    {(props.imagen !== undefined) && 
                    <img alt="" src={props.imagen} className='imgUsuario2'/> }
                    
                    <div className='containerDatos'>
                        {<div className='labelNombre' style={{
                                textOverflow: 'ellipsis',
                                overflow: 'hidden',
                                whiteSpace: 'wrap',
                                wordBreak: 'break-all',
                                maxWidth: '300px',
                        }}>{props.usuario}</div>}
                        <div className='labelDescripcion'>{props.nombre}</div>
                        {(props.razonSocial !== undefined) && <div className='labelDescripcion'>{props.razonSocial}</div>}
                        {(props.cuit) && <div className='labelDescripcion'>{props.cuit.slice(0,2)}-{props.cuit.slice(2,10)}-{props.cuit.slice(10,11)}</div>}
                        {(props.descripcion3 !== undefined) && <div className='labelDescripcion' style={{
                                textOverflow: 'ellipsis',
                                overflow: 'hidden',
                                maxWidth: '300px',
                        }}>{props.descripcion3}</div>}
                    </div>
                    {(props.opciones !== undefined) && 
                    <div onClick={(e)=>{e.stopPropagation()}} className='iconMenu'>
                        <Col>
                        <PopupState variant="popover" popupId={"nuevo-usuario-menu"}>
                            {popupState => (
                                <React.Fragment>
                                    <IconButton {...bindTrigger(popupState)}>
                                        <MoreVertIcon />
                                    </IconButton>
                                <Menu {...bindMenu(popupState)}>
                                    {
                                        props.opciones.map((x)=>{return x!==undefined ? <MenuItem onClick={(...args)=>{x.handler(...args);popupState.close(...args)}}>{x.nombre}</MenuItem> : undefined})
                                    }
                                </Menu>
                                </React.Fragment>
                            )}
                        </PopupState>
                        </Col>
                    </div>}
                </div>            
            </div>
    }

class ListaUsuariosPaginada extends React.Component {

    render() {

        return (
            <Paper style={{backgroundColor:"#FFFFFF", borderRadius: '10px'}}>
                <div >
                    <div style={{padding: '18px 24px', borderBottomStyle:"solid", borderBottomWidth: "1px", borderBottomColor:"#9B9B9B" }}>
                        <div style={{fontFamily:"Roboto", fontSize:"20px", fontWeight:'bold',  textTransform: 'uppercase'}}>{this.props.titulo}</div>
                    </div>
                    <div style={{padding: '24px'}}>
                        <Row between="xs">
                            {this.props.usuarios.result && this.props.usuarios.result.map(x=>
                            <Col sm={12} md={6} lg={6} style={{margin: '10px 0px'}}>
                                <ItemUsuario onClick={()=>{this.props.handleOpenModal && this.props.handleOpenModal(x)}} {...this.props.mapToItem(x)}/>
                            </Col>)}
                        </Row>
                    </div>
                </div>
                <Pagination handleOnChange={this.props.handleOnPagination} page={this.props.usuarios.currentPage + 1  || 0} totalPages={this.props.usuarios.totalObjects !== 0 ? this.props.usuarios.totalPages : 0}/>

                {this.props.tipo === "usuariosNuevos" && <Dialog 
                    disableBackdropClick={true}
                    fullWidth={true}
                    maxWidth={'sm'}
                    open={this.props.openModal}
                    onClose={this.props.handleOnCloseModal}>
                    <div style={{width:"100%", padding:"12px"}}>
                    <div style={{verticalAlign:"center",textAlign:"center", paddingTop:"30px"}}>
                            <div>{ "Esta por habilitar al usuario "+ this.props.pedido.nombreUsuario}</div>
                        </div>
                        <div style={{textAlign:"left", marginTop:"44px", paddingLeft:"55%"}}>
                            <Button style={{marginRight:"12px"}} className="btnSecundario" onClick={this.props.handleCloseModal} >Cancelar</Button>
                            <Button className="btnPrincipal" onClick={()=>{this.props.handleEliminar(this.props.pedido.idPedido)}}>Habilitar</Button>
                        </div>
                    </div>
                </Dialog>

                }
            </Paper>
        )
    }
}

ListaUsuariosPaginada.propTypes = {
    usuarios: PropTypes.array.isRequired,
    mapToItem: PropTypes.func,
    titulo: PropTypes.func.isRequired,
    handleOnPagination: PropTypes.func.isRequired,
    openModal: PropTypes.bool,
    handleCloseModal: PropTypes.func,
    handleOpenModal: PropTypes.func,
    pedido: PropTypes.object,
    resultadoAccion: PropTypes.bool,
    handleEliminar: PropTypes.func,
    mensajeAccion: PropTypes.string,
    tipo: PropTypes.string,
};

export default ListaUsuariosPaginada